import { createReducer, on } from '@ngrx/store';
import { initialState } from './file-details.state';
import * as FileDetailsActions from './file-details.actions';

export const fileDetailsReducer = createReducer(
  initialState,

  on(FileDetailsActions.loadFileDetails, state => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(FileDetailsActions.loadFileDetailsSuccess, (state, { file }) => ({
    ...state,
    file,
    isLoading: false,
    error: null,
  })),

  on(FileDetailsActions.loadFileDetailsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(FileDetailsActions.loadFileStatuses, state => ({
    ...state,
    isLoadingStatuses: true,
    error: null,
  })),

  on(FileDetailsActions.loadFileStatusesSuccess, (state, { statuses }) => ({
    ...state,
    statuses,
    isLoadingStatuses: false,
    error: null,
  })),

  on(FileDetailsActions.loadFileStatusesFailure, (state, { error }) => ({
    ...state,
    isLoadingStatuses: false,
    error,
  })),

  on(FileDetailsActions.updateFileStatus, state => ({
    ...state,
    isUpdating: true,
    error: null,
  })),

  on(
    FileDetailsActions.updateFileStatusSuccess,
    (state, { id, fileStatusId }) => {
      const statusName = state.statuses.find(
        s => s.id === fileStatusId
      )?.fileStatus;
      return {
        ...state,
        isUpdating: false,
        file:
          state.file && state.file.id === id && statusName
            ? {
                ...state.file,
                fileStatusName: statusName,
                fileStatusId,
              }
            : state.file,
      };
    }
  ),

  on(FileDetailsActions.updateFileStatusFailure, (state, { error }) => ({
    ...state,
    isUpdating: false,
    error,
  }))
);
